import { Injectable } from '@angular/core';
import { AuthenticationService } from '../authentication/authentication.service';
import { UserPreferencesStore } from '../stores/user-preferences-store.service';
import { FeatureFlagService } from './feature-flag.service';
import { InternationalizationService } from '@core/services/internationalization.service';
import moment from 'moment-timezone';

@Injectable()
export class AppInitializerService {
    constructor(
        private authenticationService: AuthenticationService,
        private featureFlagService: FeatureFlagService,
        private userPreferencesStore: UserPreferencesStore,
        private internationalizationService: InternationalizationService
    ) {}

    async initialize(): Promise<void> {
        moment.tz.setDefault(moment.tz.guess());
        this.internationalizationService.initialize();
        await this.authenticationService.loadAuthenticatedUserFromToken();
        this.featureFlagService.initialize();

        if (this.authenticationService.isAuthenticated()) {
            await this.userPreferencesStore.initialize(this.authenticationService.user.id);
        }

        return new Promise<void>((resolve) => {
            resolve();
        });
    }
}
